
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "TableHeader",
})
export default class extends Vue {
}
